import React from "react";
import styles from "./box.module.scss";
import { Link } from "react-router-dom";
import { GrStatusGood } from "react-icons/gr";
import { FaFileDownload } from "react-icons/fa";


const Box = ({img_1 , img_2,title_1,title_2,sub_title_1,sub_title_2,content_1,content_2,links}) => {
  return (
    <section className={styles.box_container}>
      <div className={styles.___container}>
        {/* Box 1  */}
        <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={img_1} alt='img_1' loading="lazy"/>
              </div>
            </div>
            <div className={styles.__box_rightside}>
              <Link to='#' className={styles._headding}>
              <GrStatusGood /> {title_1}
              </Link>
              <strong className={styles.__strong}>
              {sub_title_1}
              </strong>
              <p className={styles.__content}>
              {content_1}
              </p>
            </div>
          </div>
        </div>
        {/* Box 2  */}
        {img_2 &&
        <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_rightside}>
              <Link to='#' className={styles._headding}>
              <GrStatusGood /> {title_2}
              </Link>
              <strong className={styles.__strong}>
              {sub_title_2}
              </strong>
              <p className={styles.__content}>
                {content_2}
              </p>
              {links && links.map((ele,i)=>{return(
              <button className={styles["product___btn"]} key={i}>
                <a href={ele.link} download><FaFileDownload/> | {ele.linkName}</a>
              </button>
              )})}
            </div>
            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={img_2} alt='img_2' loading="lazy"/>
              </div>
            </div>
          </div>
        </div>}
      </div>
    </section>
  );
};

export default Box;
